// Imports
  // React
  import { useState, useEffect } from 'react';




const Cookies = () => {

    const [cookies, setCookies] = useState(sessionStorage.getItem('cookies') || "")

    useEffect(() => {
      if(cookies){
        document.getElementsByClassName("cookies")[0].style.display = "none";
      }
    }, [])

    const cookiesHandler = () => {
        setCookies(true)
        sessionStorage.setItem('cookies', true);
        document.getElementsByClassName("cookies")[0].style.display = "none";
    }


  return (
    <div className="cookies">
      <div className="cookies-advice">
        <p>Al navegar por este sitio acepta el uso de cookies para agilizar tu experiencia de usuario.</p>
        <div className="cookies-buttons">
            <a className="admin-button" href="http://www.cotillonscraft.com.ar/legal/politica-de-cookies" target="_blank" rel="noopener noreferrer">Ver más</a>
            <button className="admin-button" onClick={() => cookiesHandler()}>Aceptar</button>
        </div>
      </div>
    </div>
  )
}

export default Cookies
